import React from 'react'
import { Route } from 'react-router-dom'
import { FormProvider } from 'react-hook-form'

import Terminos from './Terminos'
import DatosContribuyente from './DatosContribuyente'
import DatosActividadComercial from './DatosActividadComercial'
import Comprobante from './Comprobante'
import Error from './Error'
import Botones from './Botones'

function CustomSwitch({ methods }) {
  return (
    <FormProvider {...methods}>
      <Route exact path="/ddjj/alta/terminos" component={Terminos} />
      <Route
        exact
        path="/ddjj/alta/datos-contribuyente"
        component={DatosContribuyente}
      />
      <Route
        exact
        path="/ddjj/alta/datos-actividades"
        component={DatosActividadComercial}
      />
      <Route exact path="/ddjj/alta/comprobante" component={Comprobante} />
      <Route exact path="/ddjj/alta/error" component={Error} />
      <Botones />
    </FormProvider>
  )
}

export default CustomSwitch
